import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
var moment = require('moment');

class OrderToPrint extends Component {
	render() {
		const tableStyle = {
			border: '1px solid black',
			borderCollapse: 'collapse',
			padding: '4px',
		};

		const order = this.props.order;

		const formattedDate = moment().format('DD/MM/YYYY');
		return (
			<div
				style={{
					padding: '30px',
					fontFamily: 'Times New Roman',
					width: '100%',
					fontWeight: '600',
				}}
			>
				<Grid
					container
					direction='row'
					justify='space-between'
					alignItems='baseline'
				>
					<Grid
						style={{
							fontSize: '45px',
						}}
						item
						xs={4}
					>
						Kitpet
					</Grid>
					<Grid
						style={{
							fontSize: '22px',
						}}
						item
						xs={8}
					>
						Invoice NO: {`${order?._id}`}
					</Grid>
				</Grid>
				<Grid container direction='row' justify='center' alignItems='center'>
					<div
						style={{
							fontSize: '45px',
							margin: '40px 0',
						}}
					>
						TAX INVOICE
					</div>
				</Grid>
				<div
					style={{
						fontSize: '20px',
						marginTop: '30px',
						marginBottom: '30px',
					}}
				>
					<Grid
						container
						direction='row'
						justify='space-between'
						alignItems='center'
					>
						<Grid item xs={6}>
							Kitpet
						</Grid>
						<Grid item xs={6}>
							Invoice Date: {`${formattedDate}`}
						</Grid>
					</Grid>

					<Grid
						container
						direction='row'
						justify='space-between'
						alignItems='center'
					>
						<Grid item xs={6}>
							39 Ruby st BALWYN VIC 3103
						</Grid>
						<Grid item xs={6}>
							Customer: {order?.address?.receiver}
						</Grid>
					</Grid>

					<Grid
						container
						direction='row'
						justify='space-between'
						alignItems='center'
					>
						<Grid item xs={6}>
							TEL: 0450 420342
						</Grid>
						<Grid item xs={6}>
							TEL: {order?.address?.phoneNumber}
						</Grid>
					</Grid>

					<Grid
						container
						direction='row'
						justify='space-between'
						alignItems='center'
					>
						<Grid item xs={6}>
							ABN: 79 638 453 040
						</Grid>
						<Grid item xs={6}>
							Address: {order?.address?.address}
						</Grid>
					</Grid>
				</div>

				<table
					style={{
						...tableStyle,
						marginLeft: '40px',
					}}
				>
					<thead>
						<th style={tableStyle}>Description</th>
						<th style={tableStyle}>Quantity</th>
						<th style={tableStyle}>Line total(AUD)</th>
					</thead>
					<tbody>
						{order.selectedItems.map(product => {
							return (
								<tr>
									<td style={tableStyle}>{product.subProductName}</td>
									<td style={tableStyle}>{product.quantity}</td>
									<td style={tableStyle}>
										{(product.unitPrice * product.quantity).toFixed(2)}
									</td>
								</tr>
							);
						})}
						<tr>
							<td></td>
							<td style={tableStyle}>Postage</td>
							<td style={tableStyle}>{order.shipmentPrice}</td>
						</tr>
						<tr>
							<td></td>
							<td style={tableStyle}>Subtotal</td>
							<td style={tableStyle}>{order.totalPrice}</td>
						</tr>
						<tr>
							<td></td>
							<td style={tableStyle}>Total(GST included)</td>
							<td style={tableStyle}>{order.totalPrice}</td>
						</tr>
					</tbody>
				</table>
				<div
					style={{
						fontSize: '20px',
						fontWeight: '700',
						marginTop: '40px',
					}}
				>
					Bank Details
				</div>
				<div
					style={{
						fontWeight: '500',
					}}
				>
					<p>Bank: WESTPAC </p>
					<p>Acc Name: EMPEROR</p>
					<p>BSB: 033089</p>
					<p>Acc No: 644275</p>
				</div>
			</div>
		);
	}
}

export default OrderToPrint;
